import { call, put } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';
import apiRequests from 'config/services';
import { takeLatest } from 'redux-saga/effects';
import { sagaGetCalculationProcessStepListingAction } from 'saga/actions/calculationprocessStep';
import { calculationProcessStepConstants } from 'saga/actions/calculationprocessStep';

export function* deleteCalculationProcessStepSaga(
  action: PayloadAction<{ uuid: string }>
): SagaIterator {
  try {
    // Destructure from the action payload
    const { uuid } = action.payload;

    // Call your API function with both arguments
    yield call(apiRequests.deleteCalculationProcessStep, uuid);

    yield put(sagaGetCalculationProcessStepListingAction())      // Refresh the list of assemblies
  } catch (e) {
  }
}

// Listener saga
export function* deleteCalculationProcessStepHook() {
  // on SAGA_GET_SEARCH_RESULTS action, run getSearchResultsSaga
  yield takeLatest(calculationProcessStepConstants.SAGA_DELETE_PROCESS_STEP, deleteCalculationProcessStepSaga)
}
